import React, { useState, useEffect } from "react";
import "./Toast.css";

function Toast({ type, message, duration = 5000, onClose }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => {
          if (onClose) onClose();
        }, 300); // Wait for fade out animation
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 300);
  };

  if (!message) return null;

  return (
    <div
      className={`toast-component toast-component-${type} ${isVisible ? "toast-component-visible" : "toast-component-hidden"}`}
    >
      <div className="toast-component-content">
        <span className="toast-component-message">{message}</span>
        <button className="toast-component-close" onClick={handleClose}>
          ×
        </button>
      </div>
    </div>
  );
}

export default Toast;
